var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-overlay"},[_c('infinity-loading'),_c('p',{staticClass:"pdf-overlay__text"},[_vm._v(_vm._s(_vm.$t("metrics.preparingPdf")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }